import { BdArrayUtil } from '@bindoc-projects/util-domain-lib';
import type {
  FilterConditionPluginSpecification,
} from '../filter.plugin';
import {
  FilterConditionPluginImpl
} from '../filter.plugin';
import type {
  BdCondition,
} from '@bindoc-projects/condition-domain-lib';
import {
  BdContentCondition,
} from '@bindoc-projects/condition-domain-lib';
import type { AtVirtualClinicTissAAtemwegszugang } from '@bindoc-projects/virtual-clinic-domain-lib';

export const AT_TISS_A_ATEMWEGSZUGANG_CONDITION_ID = 'tissAAtemwegszugang';
export const AtFilterConditionTissAAtemwegszugangPluginType: FilterConditionPluginSpecification<
  AtVirtualClinicTissAAtemwegszugang[],
  AtFilterConditionTissAAtemwegszugangDto,
  AtTissAAtemwegszugangCondition
> = {
  type: 'tissAAtemwegszugang',
  category: 'case',
  displayName: { de: 'TISS-A: Atemwegszugang' },
  sortingIndex: 23,
  occurrence: 'single',
  fromObject(
    obj: AtFilterConditionTissAAtemwegszugangDto,
  ): FilterConditionPluginImpl<AtVirtualClinicTissAAtemwegszugang[]> {
    return new AtFilterConditionTissAAtemwegszugangPlugin(obj.tissAAtemwegszugang);
  },
  fromCondition(
    jsonObj: AtTissAAtemwegszugangCondition,
  ): FilterConditionPluginImpl<AtVirtualClinicTissAAtemwegszugang[]> {
    return new AtFilterConditionTissAAtemwegszugangPlugin(jsonObj.includes ?? []);
  },
  newInstance(): FilterConditionPluginImpl<AtVirtualClinicTissAAtemwegszugang[]> {
    return new AtFilterConditionTissAAtemwegszugangPlugin([]);
  },
};

export class AtFilterConditionTissAAtemwegszugangPlugin extends FilterConditionPluginImpl<
  AtVirtualClinicTissAAtemwegszugang[],
  AtFilterConditionTissAAtemwegszugangDto
> {
  static override Specification: FilterConditionPluginSpecification<
    AtVirtualClinicTissAAtemwegszugang[],
    AtFilterConditionTissAAtemwegszugangDto,
    AtTissAAtemwegszugangCondition
  > = AtFilterConditionTissAAtemwegszugangPluginType;

  constructor(
    protected tissAAtemwegszugang: AtVirtualClinicTissAAtemwegszugang[],
  ) {
    super(AtFilterConditionTissAAtemwegszugangPluginType.type);
  }

  clone(): AtFilterConditionTissAAtemwegszugangPlugin {
    return new AtFilterConditionTissAAtemwegszugangPlugin([
      ...this.tissAAtemwegszugang,
    ]);
  }

  override equals(other: AtFilterConditionTissAAtemwegszugangPlugin): boolean {
    return (
      super.equals(other) &&
      BdArrayUtil.equals(this.tissAAtemwegszugang, other.tissAAtemwegszugang)
    );
  }

  override validationToText(): string {
    if (this.tissAAtemwegszugang.length === 0) {
      return 'Mindestens einen Atemwegszugang auswählen';
    } else {
      return '';
    }
  }

  toCondition(): BdCondition | null {
    return new AtTissAAtemwegszugangCondition(this.tissAAtemwegszugang, []);
  }

  toText(): string | null {
    return this.tissAAtemwegszugang.length === 1
      ? 'ein Atemwegszugang'
      : `${this.tissAAtemwegszugang.length} Atemwegszugänge`;
  }

  toJSON(): AtFilterConditionTissAAtemwegszugangDto | null {
    return {
      type: this.type,
      tissAAtemwegszugang: this.tissAAtemwegszugang,
    };
  }

  toValue(): AtVirtualClinicTissAAtemwegszugang[] {
    return this.tissAAtemwegszugang;
  }
}

export class AtTissAAtemwegszugangCondition extends BdContentCondition<AtVirtualClinicTissAAtemwegszugang> {
  constructor(
    includes: AtVirtualClinicTissAAtemwegszugang[],
    excludes: AtVirtualClinicTissAAtemwegszugang[],
  ) {
    super(AT_TISS_A_ATEMWEGSZUGANG_CONDITION_ID, includes, excludes);
  }
}

interface AtFilterConditionTissAAtemwegszugangDto {
  type: string;
  tissAAtemwegszugang: AtVirtualClinicTissAAtemwegszugang[];
}
